import { Text } from 'components/v4';

const formatTimeRemaining = (timeRemaining) => {
    const minutes = Math.floor(timeRemaining / 60000);
    const seconds = Math.floor((timeRemaining % 60000) / 1000);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

function TpmTimeRemaining({ timeRemaining }) {
    const content = formatTimeRemaining(timeRemaining);
    return (
        <Text
            fontSize="sm"
            color={timeRemaining === 0 ? 'red.500' : 'gray.600'}>
            Time until request expires:{' '}
            <Text
                as="span"
                fontWeight="semibold"
                color={timeRemaining === 0 ? 'red.500' : 'inherit'}>
                {content}
            </Text>
        </Text>
    );
}

export default TpmTimeRemaining;
